/**
 * Component: Customers header
 * -----------------------------------------------------------------------------
 * Controls customers header navigation toggle functionality.
 *
 */
import classes from '~/config/classes'

/**
 * DOM selectors.
 */
const selectors = {
  icons: '[js-customers-header="icons"]',
  navigation: '[js-customers-header="navigation"]',
  toggle: '[js-customers-header="toggle"]',
}

/**
 * Export customers navigation.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    icons: document.querySelector(selectors.icons),
    navigation: document.querySelector(selectors.navigation),
    toggle: document.querySelector(selectors.toggle),
  }

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners()
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    if (!nodeSelectors.toggle) {
      return
    }

    nodeSelectors.toggle.addEventListener('click', toggleNavigation)
  }

  /**
   * Toggle display of navigation.
   */
  function toggleNavigation() {
    nodeSelectors.icons.classList.toggle(classes.active)
    nodeSelectors.navigation.classList.toggle(classes.active)

    if (nodeSelectors.navigation.classList.contains(classes.active)) {
      nodeSelectors.toggle.setAttribute('aria-expanded', true)
      return
    }

    nodeSelectors.toggle.setAttribute('aria-expanded', false)
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
